import RescheduleLesson from './RescheduleLesson';

export default RescheduleLesson;
